/* v1 | 5 November 2026 | Native form labels, completion announcements and a bounded loading fallback. */
(function () {
  'use strict';
  var hooked = false;
  var watched = new WeakSet();
  var fields = {
    FirstName: ['First name', 'given-name'], LastName: ['Last name', 'family-name'],
    Email: ['Email address', 'email'], Country: ['Country', 'country-name'], City: ['City', 'address-level2']
  };
  function label(form) {
    Object.keys(fields).forEach(function (name) {
      var field = form.querySelector('[name="' + name + '"]');
      if (!field) return;
      var named = field.getAttribute('aria-label') || field.getAttribute('aria-labelledby');
      var labelled = field.labels && Array.from(field.labels).some(function (item) { return item.textContent.trim(); });
      if (!named && !labelled) field.setAttribute('aria-label', fields[name][0]);
      if (!field.getAttribute('autocomplete')) field.setAttribute('autocomplete', fields[name][1]);
    });
  }
  function originFor(form) {
    var origin = form.closest('.sign-up-input-wrapper');
    if (origin && origin.closest('#shopify-section-footer')) return origin;
    if (!form.closest('#modal-test')) return null;
    var sdk = document.querySelector('#shopify-section-footer script[src*="/js/forms2/js/forms2"]');
    return sdk && sdk.closest('.sign-up-input-wrapper');
  }
  function complete(form, origin) {
    if (form.dataset.fliteSignupAnnounced === 'true') return;
    form.dataset.fliteSignupAnnounced = 'true';
    if (origin) {
      origin.classList.add('flite-signup-complete');
      Array.from(origin.children).forEach(function (child) {
        if (child.matches('.sign-up-header') || (child.tagName === 'P' && child.querySelector('a[href="https://www.brunswick.com/privacy-policy"]') && child.querySelector('a[href="https://www.brunswick.com/terms-of-use"]'))) {
          child.hidden = true;
        }
      });
      var wrapper = origin.closest('.dd-sign-up-wrapper');
      if (wrapper) {
        var intro = wrapper.querySelector('.dd-sign-up-content-wrapper');
        if (intro) intro.hidden = true;
      }
    }
    var status = document.getElementById('flite-native-signup-status');
    if (!status) {
      status = document.createElement('p');
      status.id = 'flite-native-signup-status';
      status.className = 'flite-visually-hidden';
      status.setAttribute('role', 'status');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('aria-atomic', 'true');
      document.body.appendChild(status);
    }
    status.textContent = 'Thank you for signing up.';
  }
  function hook() {
    if (hooked || !window.MktoForms2 || typeof window.MktoForms2.whenReady !== 'function') return;
    hooked = true;
    window.MktoForms2.whenReady(function (instance) {
      var element = instance.getFormElem && instance.getFormElem();
      var form = element && element[0];
      if (!form || form.dataset.fliteSignupAccessible === 'true') return;
      var origin = originFor(form);
      if (!origin) return;
      form.dataset.fliteSignupAccessible = 'true';
      label(form);
      if (typeof instance.onSuccess === 'function') instance.onSuccess(function () { complete(form, origin); });
    });
  }
  function inspect(root) {
    root.querySelectorAll('form[id^="mktoForm_"]').forEach(label);
    hook();
  }
  function watch(root) {
    if (!root || watched.has(root)) return;
    watched.add(root);
    inspect(root);
    var observer = new MutationObserver(function () { inspect(root); });
    observer.observe(root, { childList: true, subtree: true });
    root.querySelectorAll('script[src*="/js/forms2/js/forms2"]').forEach(function (script) { script.addEventListener('load', hook, { once: true }); });
  }
  function modalFallback(modal) {
    if (!modal || modal.dataset.fliteLoadingFallback) return;
    modal.dataset.fliteLoadingFallback = 'true';
    var timer = null;
    var message = null;
    function loaded() {
      return !!modal.querySelector('#dotdigital-modal-form input:not([type="hidden"]), #dotdigital-modal-form select, #dotdigital-modal-form iframe[src]');
    }
    function sync() {
      var open = modal.getAttribute('aria-hidden') === 'false';
      if (!open || loaded()) {
        if (timer !== null) window.clearTimeout(timer);
        timer = null;
        if (message) { message.remove(); message = null; }
        return;
      }
      if (timer !== null || message) return;
      timer = window.setTimeout(function () {
        timer = null;
        if (modal.getAttribute('aria-hidden') !== 'false' || loaded()) return;
        message = document.createElement('div');
        message.className = 'flite-signup-load-message';
        message.setAttribute('role', 'status');
        var text = document.createElement('p');
        text.textContent = 'The signup form is taking longer than expected. Please try again.';
        var retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'button button--white';
        retry.textContent = 'Try again';
        retry.addEventListener('click', function () { window.location.reload(); });
        message.appendChild(text);
        message.appendChild(retry);
        var container = modal.querySelector('#dotdigital-modal-form');
        if (container) container.insertAdjacentElement('afterend', message);
      }, 15000);
    }
    var observer = new MutationObserver(sync);
    observer.observe(modal, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
    sync();
  }
  function init() {
    watch(document.getElementById('shopify-section-footer'));
    watch(document.getElementById('modal-test'));
    modalFallback(document.getElementById('modal-test'));
    hook();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  window.addEventListener('load', init, { once: true });
  document.addEventListener('shopify:section:load', init);
})();
